export default "__VITE_ASSET__DNv3pmg7__"